export const BankAccountRoute = 'account/bankaccount'
export const BankAccountEditRoute = 'account/bankaccount/edit'
